exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{border-color:red!important;background:#fdd}.error:focus{outline-color:#f99}.nice-select .current{width:-webkit-fill-available!important;display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.step-progress__bar{align-items:center;display:flex;height:100px;justify-content:space-between;margin-bottom:0!important;width:100%}.bg-menu{background:#55988d!important;box-shadow:5px 5px 40px}@media (max-width:600px){.step-progress__bar{height:50px}.bg-menu{background:transparent!important;box-shadow:0 0 0}.header_menu{box-shadow:10px 10px 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad18f9bc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/GrayZone/QuotationSection.vue
// module id = 915
// module chunks = 0